import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage = 'https://static.prod-images.emergentagent.com/jobs/a9e4d36a-e5ff-43e1-ab5f-86fa29a8738a/images/f7af2744eda1a28c37533f7f310272cd93ab431ecef070ccdc2db85bc39554d0.png',
  structuredData
}) => {
  const siteName = 'Trinity Electronics (Anchilex)';
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content="Trinity Electronics Co., Ltd." />
      <meta name="robots" content="index, follow" />
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={siteName} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Geo Tags for Taiwan */}
      <meta name="geo.region" content="TW" />
      <meta name="geo.placename" content="New Taipei City, Taiwan" />
      
      {/* Language */}
      <meta httpEquiv="content-language" content="en" />
      <link rel="alternate" hrefLang="en" href={canonicalUrl} />
      
      {/* Structured Data / JSON-LD */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

// Structured data templates
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Trinity Electronics Co., Ltd.",
  "alternateName": "Anchilex",
  "url": "https://www.trinity-tw.com",
  "logo": "https://www.trinity-tw.com/logo.png",
  "description": "OEM/ODM imaging solutions provider specializing in dashcams, vehicle cameras, surveillance systems, and ultrasonic animal deterrence.",
  "foundingDate": "1995",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "15F.-10, No. 99, Sec. 1, Xintai 5th Rd., Xizhi Dist.",
    "addressLocality": "New Taipei City",
    "postalCode": "22175",
    "addressCountry": "TW"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+886-2-2697-1626",
    "contactType": "sales",
    "availableLanguage": ["English", "Chinese", "German", "French", "Russian", "Swedish", "Japanese"]
  },
  "sameAs": [
    "https://www.anchilex.com"
  ]
};

export const productSchema = (name, description, category) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  "name": name,
  "description": description,
  "category": category,
  "manufacturer": {
    "@type": "Organization",
    "name": "Trinity Electronics Co., Ltd."
  }
});

export const serviceSchema = (name, description) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "name": name,
  "description": description,
  "provider": {
    "@type": "Organization",
    "name": "Trinity Electronics Co., Ltd."
  },
  "areaServed": "Worldwide"
});

export default SEO;
